export default class SuccessBanner {
  closeIcons = document.getElementsByClassName('js-product-review-success-banner-close');
  banners = document.getElementsByClassName('js-product-review-success-banner');

  show = () => {
    [...this.banners].forEach((banner) => banner.classList.remove('hidden'));
  };

  close = () => {
    [...this.banners].forEach((banner) => banner.classList.add('hidden'));
  };

  initializeEventListeners = () => {
    [...this.closeIcons].forEach((closeIcon) => closeIcon.addEventListener('click', this.close));
  };
}
